import { cn } from '@/helpers/shadCnUtils';

interface ImagesButtonProps {
  title: string;
  imageSource?: Array<string>;
  hoverText: string;
  onClick: () => void;
  blankCount?: number;
}

export function ImagesButton({ title, imageSource, hoverText, onClick, blankCount = 4 }: ImagesButtonProps) {
  return (
    <button
      onClick={onClick}
      title={hoverText}
      className={cn(
        'group relative flex w-fit cursor-pointer items-center justify-center rounded-lg border border-gray-300 bg-white p-2.5 transition-all duration-200 hover:border-teal-500',
      )}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex gap-2">
          {imageSource && imageSource.length
            ? imageSource.map((source, index) => (
                <img key={index} src={source} alt={title} className="size-5 rounded-lg object-cover" />
              ))
            : Array.from({ length: blankCount }).map((_, index) => (
                <div
                  key={index}
                  className="h-8 w-8 rounded-lg bg-gray-200 transition-colors duration-200 group-hover:bg-gray-300"
                />
              ))}
        </div>
      </div>
    </button>
  );
}
